import { api } from "./client";
import type { Professional } from "./types";

export interface ProfessionalFilters {
  isActive?: boolean;
  specialty?: string;
}

export const professionalsService = {
  async list(filters?: ProfessionalFilters): Promise<Professional[]> {
    return api.get<Professional[]>("/professionals", filters);
  },

  async getSpecialties(): Promise<string[]> {
    return api.get<string[]>("/professionals/specialties");
  },

  async getById(id: string): Promise<Professional> {
    return api.get<Professional>(`/professionals/${id}`);
  },

  async getSchedule(id: string, date?: string): Promise<{
    date: string;
    workingHours: Record<string, { start: string; end: string } | null> | null;
    appointments: Array<{
      id: string;
      startTime: string;
      endTime: string;
      patient: { id: string; name: string; phone?: string };
      procedure: { id: string; name: string; duration: number };
    }>;
  }> {
    return api.get(`/professionals/${id}/schedule`, { date });
  },

  async update(id: string, data: Partial<Professional>): Promise<Professional> {
    return api.put<Professional>(`/professionals/${id}`, data);
  },
};
